define('views/modules/calendar/nutrition/food/search/food-search-content',[
    // Libs
    'underscore', 'backbone', 'utils',
    // Services
    'services/i18n',
    // collections
    'collections/calendar/nutrition/foods',
    // Views
    'views/parts/form/textbox',
    'views/parts/fetch-button',
    'views/modules/calendar/nutrition/food/food-content',
    'views/modules/calendar/nutrition/food/list/food-list',
], function(
    // Libs
    _, Backbone, U,
    // Services
    i18n,
    // collections
    CFoods,
    // Views
    VTextBox,
    VFetchButton,
    VFoodContent,
    VFoodList
) {
    var POPULAR_RESULTS_COUNT = 10;
    var VFoodContentSearch = VFoodContent.extend({

        initialize: function(options) {

            var tmpCollection = this.tmpCollection = new CFoods(null, { full: true, sort: false });
            var collection = this.collection = new CFoods(null, { full: true, sort: false }),
                view = _.extend(this.view, {
                    list: {},
                    search: new VTextBox({
                        label: 'calendar:Search foods',
                        labelposition: 'top',
                    })
                });

            this.listenTo(view.search, 'submit', this.onQuerySubmit);
            this.listenTo(collection, { 'sync': this.onCollectionSync, });
        },

        render: function() {
            this.resetList();
            VFoodContentSearch.__super__.render.apply(this, arguments);
            var view = this.view,
                zone = this.zone;
            this.assign(view.search, zone.$search);
            return this;
        },

        renderList: function() {
            var container = document.createDocumentFragment();

            _.each(this.view.list, function(view) {
                container.appendChild(view.render().el);
            });

            this.zone.$list.append(container);
            return this;
        },

        _initCustomFoodList: function(models) {
            var views = this.view.list,
                list = views.custom;
            if (!list) {
                // lazily create new list
                views.custom = list = new VFoodList({
                    title: i18n.t('calendar:your-custom-foods'),
                    favorite: this.favorite,
                    async: false,
                });

                this.zone.$list.append(list.render().el);
            }

            list.addFood(models);

            return list;
        },

        _initMainFoodList: function() {
            var views = this.view.list,
                list = views.main;

            if (!list) {
                // lazily create new list
                views.main = list = new VFoodList({
                    title: i18n.t('calendar:all-foods'),
                    favorite: this.favorite,
                    async: false,
                    defaultServing: true
                });

                this.zone.$list.append(list.render().el);
            }

            var collection = this.collection.clone();
            list.addFood(collection.models.filter(function(food) { return food.get('database') !== null }).slice(POPULAR_RESULTS_COUNT, collection.models.length));

            return list;
        },

        _initPopularFoodList: function() {
            var views = this.view.list,
                list = views.popular;
            if (!list) {
                // lazily create new list
                views.popular = list = new VFoodList({
                    title: i18n.t('calendar:popular-foods'),
                    favorite: this.favorite,
                    async: false,
                    defaultServing: true
                });

                this.zone.$list.append(list.render().el);
            }

            var collection = this.collection.clone();
            list.addFood(collection.first(POPULAR_RESULTS_COUNT));

            return list;
        },

        dispatchFood: function() {
            this.collection.add(this.tmpCollection.models);

            var collection = this.collection,
                customFoods = collection.sort().where({ database: null })
                popularFoods = collection.first(POPULAR_RESULTS_COUNT);

            this.view.list = {}
            this.collection.remove(customFoods);
            this._initPopularFoodList();
            this._initCustomFoodList(customFoods);
            this._initMainFoodList();
        },

        resetList: function() {
            _.invoke(this.view.list, 'reset');
        },

        unselect: function() {
            _.invoke(this.view.list, 'unselect');
        },

        ////////////
        // events //
        ////////////
        onQuerySubmit: function(model, value) {
            this.collection.setQuery(value).getFirstPage();
            this.tmpCollection.reset();
            this.resetList();
        },
        onCollectionSync: function(collection, response, options) {
            this.dispatchFood();
        }
    });

    return VFoodContentSearch;
});

